<div class="vh-shell">
    <div class="sticky-toolbar text-[14px]">
        <p-toolbar class="text-[14px] p-0">
            <ng-template #start></ng-template>
            <ng-template #end>
                <div class="right-buttons flex flex-wrap gap-2">
                    <p-button label="Back" icon="pi pi-arrow-left" severity="secondary" (onClick)="goBack()" />
                </div>
            </ng-template>
        </p-toolbar>
    </div>

    <div class="version-history-page">
        <header class="version-history-page__header">
            <div class="version-history-page__header-text">
                <h1 class="version-history-page__title">Version History</h1>
                <p class="version-history-page__subtitle">Div 400 → 300 → 100 → maturity</p>
            </div>
            <div class="version-history-page__header-meta">
                @if (latestProductVersion) {
                    <span class="version-history-page__chip version-history-page__chip--product">
                        <span class="version-history-page__chip-label">Product</span>
                        <span class="version-history-page__chip-value">{{ latestProductVersion }}</span>
                    </span>
                }
                @if (currentVersion) {
                    <span class="version-history-page__chip version-history-page__chip--build">
                        <span class="version-history-page__chip-label">Build</span>
                        <span class="version-history-page__chip-value">{{ currentVersion }}</span>
                    </span>
                }
            </div>
        </header>

        <div class="version-history-page__content">
            <div class="version-history-page__search mb-4">
                <p-iconfield iconPosition="left" class="w-full max-w-30rem">
                    <p-inputicon styleClass="pi pi-search" />
                    <input
                        pInputText
                        type="search"
                        class="w-full"
                        placeholder="Search by version or keyword (e.g. France, 400, margin)"
                        [(ngModel)]="searchTerm"
                        (ngModelChange)="onSearchChange()"
                    />
                </p-iconfield>
                @if (searchTerm) {
                    <button type="button" class="version-history-page__clear" (click)="clearSearch()">Clear</button>
                }
            </div>

            @if (loading) {
                <p class="version-history-page__status">Loading release history…</p>
            } @else if (loadError) {
                <p class="version-history-page__status version-history-page__status--error">
                    Could not load version history. Please try again later.
                </p>
            } @else if (!filteredReleases.length) {
                <p class="version-history-page__status">No releases match your search.</p>
            } @else {
                <div class="version-timeline">
                    @for (release of filteredReleases; track release.version; let first = $first) {
                        <article
                            class="version-timeline__item"
                            [class.version-timeline__item--latest]="first && !searchTerm"
                            [class.version-timeline__item--go-live]="!!release.goLiveDivision"
                        >
                            <div class="version-timeline__rail">
                                <span class="version-timeline__badge">{{ release.version }}</span>
                                <span class="version-timeline__line" aria-hidden="true"></span>
                            </div>
                            <div class="version-timeline__body">
                                <p-card styleClass="version-timeline__card">
                                    <div class="flex flex-wrap align-items-center gap-2 mb-2">
                                        <p-tag [value]="'v' + release.version" [severity]="release.goLiveDivision ? 'warn' : 'info'" />
                                        @if (release.goLiveDivision) {
                                            <p-tag [value]="'Division ' + release.goLiveDivision + ' go-live'" severity="warn" />
                                        }
                                        @if (first && !searchTerm) {
                                            <p-tag value="Latest" severity="success" />
                                        }
                                    </div>
                                    @if (release.title) {
                                        <h2
                                            class="version-timeline__milestone-title mt-0 mb-2"
                                            [class.version-timeline__milestone-title--go-live]="!!release.goLiveDivision"
                                        >
                                            {{ release.title }}
                                        </h2>
                                    }
                                    <p class="version-timeline__period mb-2">{{ release.period }}</p>
                                    <p class="version-timeline__summary mb-3">{{ release.summary }}</p>

                                    @if (release.features?.length) {
                                        <p-panel header="New Features" [toggleable]="true" [collapsed]="true" styleClass="mb-2">
                                            <ul class="version-timeline__list">
                                                @for (item of release.features; track item) {
                                                    <li>{{ item }}</li>
                                                }
                                            </ul>
                                        </p-panel>
                                    }
                                    @if (release.enhancements?.length) {
                                        <p-panel header="Enhancements" [toggleable]="true" [collapsed]="true" styleClass="mb-2">
                                            <ul class="version-timeline__list">
                                                @for (item of release.enhancements; track item) {
                                                    <li>{{ item }}</li>
                                                }
                                            </ul>
                                        </p-panel>
                                    }
                                    @if (release.bugFixes?.length) {
                                        <p-panel header="Bug Fixes" [toggleable]="true" [collapsed]="true">
                                            <ul class="version-timeline__list">
                                                @for (item of release.bugFixes; track item) {
                                                    <li>{{ item }}</li>
                                                }
                                            </ul>
                                        </p-panel>
                                    }
                                </p-card>
                            </div>
                        </article>
                    }
                </div>
            }
        </div>
    </div>
</div>
